import { API_BASE_URL } from "../config";

export const V1 = "/api/v1";
export const BASE_URL = `${API_BASE_URL}${V1}`;
export const GENERATE_PRESIGNED_URL = "/utils/generate-presigned-url";
export const STRIPE_CREATE_CUSTOMER_PORTAL_SESSION =
  "/utils/create-customer-portal-session";
export const STRIPE_CREATE_CUSTOMER_SESSION = "/utils/create-customer-session";

// AUTH
const AUTH = `/auth`;
export const LOGIN = `${AUTH}/login`;
export const REGISTER = `${AUTH}/signup`;
export const VERIFY_EMAIL = `${AUTH}/verify-email`;
export const RESEND_VERIFY_EMAIL = `${AUTH}/resend-verification`;
export const PASSWORD_RECOVER = `${AUTH}/password-recovery/:email`;
export const PASSWORD_RESET = `${AUTH}/password-reset`;

// USER
export const USER = "/users/me";
export const CHANGE_USER_PASSWORD = `${USER}/password`;

// ACCOUNT
export const ACCOUNTS = "/accounts/:accountId";
export const LEAVE_ACCOUNT = `${ACCOUNTS}/leave`;
export const GET_ACCOUNT_USERS = `${ACCOUNTS}/users`;

// DASHBOARD
export const ARTICLE_DASHBOARD = `${ACCOUNTS}/dashboard`;

// ARTICLES
export const ARTICLES = `${ACCOUNTS}/articles`;
export const ARTICLES_BY_ID = `${ARTICLES}/:articleId`;

// ARTICLE TEMPLATE
export const TEMPLATES = `${ACCOUNTS}/templates`;
export const TEMPLATE_BY_ID = `${TEMPLATES}/:templateId`;
export const CLONE_TEMPLATE_BY_ID = `${TEMPLATES}/:templateId/clone`;

// ACCOUNT SUBSCRIPTION
export const ACTIVE_SUBSCRIPTION = `${ACCOUNTS}/subscriptions/active`;
export const SUBSCRIPTION = `${ACCOUNTS}/subscriptions`;

// DESTINATIONS
export const DESTINATIONS = `${ACCOUNTS}/destinations`;
export const DESTINATION_BY_ID = `${DESTINATIONS}/:destinationId`;
export const DESTINATION_TEST = `${ACCOUNTS}/destination-connection-test`;
export const DESTINATION_ATTACH_TO_TEMPLATE = `${DESTINATION_BY_ID}/templates/:templateId`;
export const COPY_DESTINATION = `${DESTINATIONS}/:destinationId/clone`;
export const DESTINATION_TEST_SAVED = `${DESTINATION_BY_ID}/test`;
export const DESTINATION_GOOGLE_CONNECT = `${DESTINATION_BY_ID}/google/connect`;
export const DESTINATION_GOOGLE_CREATE = `${DESTINATIONS}/google/connect`;

// GOOGLE (the user's own connection, and exporting an article to a Google Doc)
export const ARTICLE_EXPORT_GOOGLE_DOC = `${ARTICLES_BY_ID}/export/google-doc`;

// ACCOUNT TAGS
export const ACCOUNT_TAGS = `${ACCOUNTS}/tags`;
export const ACCOUNT_TAG_BY_ID = `${ACCOUNT_TAGS}/:accountTagId`;
